export default "__VITE_ASSET__e25ea5d6__"